/** Seeded PRNG so a run can be replayed exactly while tuning. */
export type Rng = {
	next(): number
	range(lo: number, hi: number): number
	gaussian(sigma: number): number
	chance(p: number): boolean
	pick<T>(xs: readonly T[]): T
}

export function makeRng(seed: number): Rng {
	let s = seed >>> 0
	const next = () => {
		s = (s + 0x6d2b79f5) >>> 0
		let t = s
		t = Math.imul(t ^ (t >>> 15), t | 1)
		t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
		return ((t ^ (t >>> 14)) >>> 0) / 4294967296
	}
	return {
		next,
		range: (lo, hi) => lo + (hi - lo) * next(),
		gaussian(sigma) {
			// Box-Muller; one sample is plenty and avoids caching state.
			const u = Math.max(next(), 1e-9)
			const v = next()
			return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v) * sigma
		},
		chance: (p) => next() < p,
		pick<T>(xs: readonly T[]): T {
			return xs[Math.floor(next() * xs.length)] as T
		},
	}
}
